<div [id]="id" class="tree-node tree-node-content item row"  [attr.name]="'wm-widget-config-'+field.displayName||field.field"   (click)="onRowSelect(field,'field')">

    <i title="{{locale.LABEL_EXPAND + '/' + locale.LABEL_COLLAPSE}}" class="toggle toggle-icon wms"
        [ngClass]="{'wms-arrow-left': collapsed,'wms-arrow-down': !collapsed}"
        *ngIf="field.fields && field.fields.length > 0" data-nodrag (click)="toggle(this, $event)"></i>
    <div class="col-xs-1">
        <input class="app-checkbox" type="checkbox" [attr.name]="'wm-widget-config-'+field.displayName||field.field"  [ngModel]="field.pcDisplay"
            (ngModelChange)="onColSelect('pcDisplay', field, $event)" />
    </div>
    <div class="col-xs-3 add-padding">
        <span class="field-displayname king " title="{{field.field}}">{{field.field}}</span>
    </div>
    <div class="col-xs-3">
        <input class="form-control app-textbox" [(ngModel)]="field.displayName"
               [attr.name]="'wm-widget-config-'+field.displayName||field.field" placeholder="Title for the column" />
    </div>
    <div class="col-xs-2">
        <select class="app-select form-control" *ngIf="!field.showInnerFields" [ngModel]="field.widget"
                [attr.name]="'wm-widget-config-'+field.displayName||field.field"
                (ngModelChange)="updateWidgetTypeChange(field, $event)">
            <option value="">{{locale.LABEL_SELECT_WIDGET_FOR_FIELD}}</option>
            <optgroup label="{{locale.LABEL_PREFERRED}}">
                <option *ngFor="let widget of fieldTypeWidgetTypeMap[extractTypefunc(field.type).toLowerCase()] | keyvalue | orderBy:'value'"
                    value="{{widget.value}}">{{widget.value}}</option>
            </optgroup>
            <optgroup label="{{locale.LABEL_INSERT_OTHERS_TAB_TITLE}}">
                <option *ngFor="let widget of otherWdgts[extractTypefunc(field.type).toLowerCase()] | keyvalue | orderBy:'value'"
                        value="{{widget.value}}">{{widget.value}}</option>
            </optgroup>
        </select>
    </div>
    <div class="col-xs-2 text-center">
        <wms-toggle [id]="'inner-fields-toggle-'+level+id" *ngIf="field.isRelated" [hideLabels]="true" [onValue]="true" [offValue]="false" [model]="field.showInnerFields"
            (onChange)="toggleInnerFields.emit({field, val: $event})" (click)="handleToggleClick($event)"></wms-toggle>
        <label class="select-label" *ngIf="field.isRelated">{{locale.LABEL_SELECT_FIELDS}}</label>
    </div>
</div>
<!--Inner columns-->
<div class="angular-ui-tree">
    <ol class="list-items angular-ui-tree-nodes" [ngClass]="{'hidden': collapsed}">
        <li *ngFor="let innerField of field.fields; index as i" class="list-item"
            [ngClass]="{'active': innerField === currentStep.selectedComponent.field}">
            <wms-fields-list [id]="id+'-'+i" [level]="level+1" [field]="innerField" [currentStep]="currentStep"
                [fieldTypeWidgetTypeMap]="fieldTypeWidgetTypeMap" [otherWdgts]="otherWdgts" [myWidgets]="myWidgets"
                (updateSelectAll)="updateSelectAll.emit($event)" (toggleInnerFields)="toggleInnerFields.emit($event)"
                (updateSelectedComponent)="updateSelectedComponent.emit($event)"
                (onWidgetTypeChange)="onWidgetTypeChange.emit($event)"></wms-fields-list>
        </li>
    </ol>
</div>
